import PropTypes from 'prop-types';
import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { connect } from "react-redux";
import { NotificationType } from 'common/data/constants';
import * as Icons from "lucide-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import { useAuthUserDetails } from 'components/Common/getAuthUserDetails';
import Loader from 'common/pageLoader';
import { useHistory } from "react-router-dom";
import NotificationModal from './notification';
import { refreshSession } from 'store/actions';

class NotificationDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
    }
    this.toggle = this.toggle.bind(this)
  }

  componentDidMount() {
    const authUserDetails = useAuthUserDetails();
    const user_id = authUserDetails[0]?.user_id;
    const unit_id = authUserDetails[0]?.unit_id;
    if (user_id && unit_id) {
      const formData = new FormData();
      formData.append("create_by",user_id)
      formData.append("unit_id",unit_id)
      this.props.notificationRequest(formData);

      const formData2 = new FormData();
      formData2.append("unit_id", unit_id);
      formData2.append("user_id", user_id);

      this.props.refreshSession(formData2);
    }
  }

  // Utility to show relative time (e.g., '5h ago')
 getTimeAgo(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffDay > 0) return `${diffDay}d ago`;
  if (diffHr > 0) return `${diffHr}h ago`;
  if (diffMin > 0) return `${diffMin}m ago`;
  return 'Just now';
}

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  toggleModal = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
      menu: !prevState.menu,
    }));
  };

  render() {
    const { t, notificationList, loading } = this.props;
    const { showModal } = this.state;
    const notificationCount = notificationList?.length || 0;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="dropdown d-inline-block"
          tag="li"
        >
          <DropdownToggle
            className="btn header-item noti-icon"
            tag="button"
            id="page-header-notifications-dropdown"
          >
            <i className="bx bx-bell bx-tada" />
            {/* <span className="badge bg-danger rounded-pill">3</span> */}
            {notificationCount > 0 && (
              <span className="badge bg-danger rounded-pill">
                {notificationCount}
              </span>
            )}
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {t("Notifications")} </h6>
                </Col>
                {/* <div className="col-auto">
                  <a href="#" className="small">
                    {" "}
                    View All
                  </a>
                </div> */}
              </Row>
            </div>

            <SimpleBar style={{ height: "230px" }}>

              {notificationList?.map((item, index) => {
                const typeData = NotificationType.find(t => t.value === item.not_type);
                const IconComponent = Icons[typeData?.icon] || Icons["Bell"];

                return (
                  <Link to="#" key={index} className="text-reset notification-item">
                    <div className="d-flex">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <IconComponent size={16} />
                        </span>
                      </div>

                      <div className="flex-grow-1">
                         <h6 className="mt-0 mb-1"><strong>{typeData?.label}</strong></h6>
                        <h6 className="mt-0 mb-1">
                          <strong style={{fontWeight: 'bold'}}>{item.emp_name}</strong>
                          <span className="float-end text-muted font-size-11">{this.getTimeAgo(item.create_dt)}</span>
                        </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">
                            <strong>{item.subject}</strong>
                          </p>
                          <p
                            className="mb-0"
                            dangerouslySetInnerHTML={{ __html: item.description }}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}

              {notificationList?.length === 0 && (
                <div className="p-3 text-center text-muted">
                  No notifications found
                </div>
              )}

            </SimpleBar>

            <NotificationModal
              isOpen={showModal}
              toggle={this.toggleModal}
              notificationList={notificationList}
            />

            {/* <SimpleBar style={{ height: "230px" }}>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      <i className="bx bx-cart" />
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {this.props.t("Your order is placed")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "If several languages coalesce the grammar"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {this.props.t("3 min ago")}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <img
                    src={avatar3}
                    className="me-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  />
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">James Lemire</h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t("It will seem like simplified English") +
                          "."}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />
                        {this.props.t("1 hours ago")}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16">
                      <i className="bx bx-badge-check" />
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {this.props.t("Your item is shipped")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "If several languages coalesce the grammar"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {this.props.t("3 min ago")}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <img
                    src={avatar4}
                    className="me-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  />
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">Salena Layfield</h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "As a skeptical Cambridge friend of mine occidental"
                        ) + "."}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />
                        {this.props.t("1 hours ago")}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </SimpleBar> */}
            <div className="p-2 border-top d-grid">
              <button
                    className="btn btn-link"
                    onClick={this.toggleModal}
                  >
                    View More..
                  </button>
              {/* <Link className="btn btn-sm btn-link font-size-14 text-center" to="#">
                <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{this.props.t("View More..")}</span>
              </Link> */}
            </div>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

// NotificationDropdown.propTypes = {
//   t: PropTypes.any,
// }

// export default withTranslation()(NotificationDropdown)


NotificationDropdown.propTypes = {
  notificationRequest: PropTypes.func,
  refreshSession: PropTypes.func,
  notifications: PropTypes.array,
  loading: PropTypes.bool,
  user: PropTypes.object,
  t: PropTypes.any,
};

// map state
const mapStateToProps = ({ Login }) => ({
  notificationList: Login.notificationList,
  loading: Login.loading,
  user: Login.userDetails,
});

// map dispatch
const mapDispatchToProps = dispatch => ({
  notificationRequest: payload =>
    dispatch({ type: "NOTIFICATION_REQUEST", payload }),
  refreshSession: payload =>
    dispatch(refreshSession(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(NotificationDropdown));
